import convertBase64ToBlob from 'Helper/convertBase64ToBlob';

const postClockInHostRequest = async (data) => {
  const selfieImage = await convertBase64ToBlob(data?.selfieImage);
  const locationImage = await convertBase64ToBlob(data?.locationImage);

  const formData = new FormData();

  formData.append('isFakeLocation', `${data?.isFakeLocation}`);
  formData.append('location', JSON.stringify(data?.location));
  formData.append('selfieImage', selfieImage);
  formData.append('locationImage', locationImage);
  formData.append('workDate', data?.workDate);
  formData.append('note', data?.note);

  return formData;
};

export default postClockInHostRequest;
